window.backdropOpen = function(){
    const body      = document.querySelector('body');

    setTimeout(     function() {
                        if(!body.classList.contains('_backdrop')){
                        body.classList.add('_backdrop');
                    }
    }, 0)
}

window.backdropClose = function(){
    const body      = document.querySelector('body');

    if(body.classList.contains('_backdrop')){
        body.classList.remove('_backdrop');
    }
}